module.exports = __webpack_public_path__ + "c746e9b92cb20af1d5770c068b8b927a.svg";